// Swiper 7.4.1

import './vendor/swiper';
import './vendor/move-to';
